const messages = {
  name: 'Manage Groups',
  pageTitle: 'Manage Groups',
  empty: 'No groups found',
  fields: {
    account: 'Account',
    application: 'Application',
    groupName: 'Group Name',
    accountName: 'Account Name',
    applicationName: 'Application Name',
  },
  placeholders: {
    selectAccount: 'Select an account',
    selectApplication: 'Select an application',
  },
  search: {
    placeholder: 'Search',
  },
  filters: {
    groupName: 'Group Name',
    accountName: 'Account',
    applicationName: 'Application',
  },
  hints: {
    pickAccountFirst: 'Select an account to load its applications',
    pickAccountAndApplication:
      'Select an account and an application to manage its groups',
    noApplications: 'No applications are assigned to this account',
  },
  actions: {
    addGroup: 'Add Group',
    edit: 'Edit',
    delete: 'Delete',
    back: 'Back',
    submit: 'Submit',
    discard: 'Discard',
  },
  delete: {
    title: 'Delete %{name}?',
    content:
      'Are you sure you want to delete this group? This action cannot be undone.',
  },
  validation: {
    accountRequired: 'Account is required',
    applicationRequired: 'Application is required',
    atLeastOneGroup: 'At least one group is required',
    groupNameRequired: 'Group Name is required',
  },
  notifications: {
    loadFailed: 'Failed to load groups',
    saveFailed: 'Failed to save groups',
    saved: 'Groups saved successfully',
    deleted: 'Group "%{name}" deleted',
    deleteFailed: 'Failed to delete group',
  },
};

export default messages;
